export default __webpack_public_path__ + "static/inter-97310231ce25ec34a047d007a5e8d7b6.woff2";